import React from "react";

import Spinner from "../../Components/Common/Spinner";


const PreviouslyOrderedProductStatus = ({status, loading}) => {
    if (loading) {
        return (
            <Spinner/>
        )
    }
    if (status !== true) {
        return null;
    }

    return (
        <span title="Dit artikel is eerder besteld"><i className="fa fa-history fa-2x text-success my-auto ml-1"/></span>
    )
}

export default PreviouslyOrderedProductStatus;